// src/firebase/auth.js
import { 
    getAuth, 
    createUserWithEmailAndPassword, 
    signInWithEmailAndPassword,
    GoogleAuthProvider,
    signInWithPopup,
    sendPasswordResetEmail,
    updateProfile,
    signOut
  } from 'firebase/auth';
  import { createOrUpdateUser } from './users';
  
  const auth = getAuth();
  
  // Register a new user with email and password
  export const registerWithEmail = async (email, password, userData) => {
    try {
      // Create user in Firebase Auth
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      // Update profile with display name and photo URL if provided
      const profileUpdates = {};
      if (userData.displayName) profileUpdates.displayName = userData.displayName;
      if (userData.avatarUrl) profileUpdates.photoURL = userData.avatarUrl;
      
      if (Object.keys(profileUpdates).length > 0) {
        await updateProfile(user, profileUpdates);
      }
      
      // Create user in Firestore with additional data
      await createOrUpdateUser({
        ...user,
        title: userData.title || '',
        phoneNumber: userData.phoneNumber || '',
        customAvatarUrl: userData.avatarUrl || ''
      });
      
      return user;
    } catch (error) {
      console.error("Error registering user:", error);
      throw error;
    }
  };
  
  // Sign in with email and password
  export const loginWithEmail = async (email, password) => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      return userCredential.user;
    } catch (error) {
      console.error("Error signing in:", error);
      throw error;
    }
  };
  
  // Sign in with Google
  export const loginWithGoogle = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      return result.user;
    } catch (error) {
      console.error("Error signing in with Google:", error);
      throw error;
    }
  };
  
  // Send password reset email
  export const resetPassword = async (email) => {
    try {
      await sendPasswordResetEmail(auth, email);
      return true;
    } catch (error) {
      console.error("Error sending password reset:", error);
      throw error;
    }
  };
  
  // Sign out user
  export const logoutUser = async () => {
    try {
      await signOut(auth);
      return true;
    } catch (error) {
      console.error("Error signing out:", error);
      throw error;
    }
  };
  
  // Get current user
  export const getCurrentUser = () => {
    return auth.currentUser;
  };